// extracted by mini-css-extract-plugin
export var active = "_df-2";
export var recordingDot = "_df-1";
export var recordingIndicator = "_df-0";